// Pushes a GA4-formatted `add_to_cart` event to the GTM dataLayer whenever a
// genuine add-to-cart request succeeds (PDP, sticky bar, quick-add modal).
// Reuses the theme's existing PUB_SUB_EVENTS.cartUpdate bus so it works
// without touching every add-to-cart call site individually.
(function () {
  function centsToAmount(cents) {
    return typeof cents === 'number' ? Math.round(cents) / 100 : 0;
  }

  function buildItem(line) {
    return {
      item_id: String(line.product_id || ''),
      item_variant_id: String(line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || '',
      item_variant: line.variant_title || '',
      item_brand: line.vendor || '',
      item_sku: line.sku || '',
      price: centsToAmount(line.final_price != null ? line.final_price : line.price),
      quantity: line.quantity || 1,
    };
  }

  function pushAddToCart(item) {
    window.dataLayer = window.dataLayer || [];
    // Clear the previous ecommerce object first, per Google's recommendation,
    // so GA4 items from an earlier event don't leak into this one.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: window.shopCurrency || 'USD',
        value: item.price * item.quantity,
        items: [item],
      },
    });
  }

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
    // Only 'product-form' represents an unambiguous add (PDP, sticky bar,
    // quick-add modal all submit through product-form.js). Bulk/quick-order
    // sources use absolute-quantity cart/update.js calls, which can also
    // represent decreases, so they're intentionally excluded here.
    if (!event || event.source !== 'product-form') return;

    var data = event.cartData;
    if (!data || data.variant_id === undefined) return;

    pushAddToCart(buildItem(data));
  });
})();
